import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { QualificationExportService } from '../../../service/qualification-export.service';

@Component({
  selector: 'wilson-shared-user-qualifications-export-trigger',
  imports: [TranslatePipe, NzButtonModule],
  templateUrl: './shared-user-qualifications-export-trigger.component.html',
  styleUrl: './shared-user-qualifications-export-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUserQualificationsExportTriggerComponent {
  private exportService = inject(QualificationExportService);

  exportSharedUserQualificationsComplementaryCertificate(): void {
    this.exportService.exportQualificationsForSingleSharedUser();
  }
}
